import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import apiService from '../services/api';

const Layout = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showApiWarning, setShowApiWarning] = useState(false);

    useEffect(() => {
        const checkApiSettings = async () => {
            try {
                const apiSettings = await apiService.settings.getApiSettings();
                // API bilgileri eksikse uyarıyı göster
                setShowApiWarning(!apiSettings?.seller_id);
            } catch (error) {
                console.error('API ayarları kontrol edilirken hata:', error);
                // Hata durumunda da uyarıyı gösterelim
                setShowApiWarning(true);
            }
        };

        // API kontrol işlemi başarısız olsa bile UI'ın çalışmaya devam etmesini sağla
        checkApiSettings().catch(() => setShowApiWarning(true));
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar isMenuOpen={isMenuOpen} />
            
            <div className="flex-1 flex flex-col overflow-hidden">
                <Header toggleMenu={toggleMenu} />
                
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 pl-0 lg:pl-64">
                    {showApiWarning && (
                        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4" role="alert">
                            <p className="font-bold">API Ayarlarınız Eksik</p>
                            <p>Trendyol entegrasyonu için API bilgilerinizi <Link to="/settings" className="underline">Ayarlar</Link> sayfasından tanımlamanız gerekiyor.</p>
                        </div>
                    )}
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout; 